import { Navigate } from 'react-router-dom';
import useDistrictRequiresTestScores from '../hooks/useDistrictRequiresTestScores';
import Loader from '../reusable/Loader';
import { NAVIGATION_LINKS_DATA } from '../../constants';

interface RequiresTestScoresRouteProps {
  children: JSX.Element;
}

const RequiresTestScoresRoute = ({ children }: RequiresTestScoresRouteProps) => {
  const { requiresTestScores, isPending } = useDistrictRequiresTestScores();

  if (isPending) return <Loader />;
  if (!requiresTestScores) return <Navigate to={NAVIGATION_LINKS_DATA.DATA_QC.path} replace />;

  return children;
};

export default RequiresTestScoresRoute;
